import { useState, useEffect, useCallback, useRef } from 'react'
import {
  fetchProjects,
  fetchSubtasks,
  fetchSubtasksByProjectId,
  fetchAircraft,
  fetchCallouts,
  fetchTechnicians,
  fetchSubtaskTechnicians,
  fetchProjectTechnicians,
  fetchProjectTechDates,
  fetchFlightLegs,
} from '../lib/api'

export function useProjects() {
  const [projects, setProjects] = useState([])
  const [subtasks, setSubtasks] = useState([])
  const [aircraft, setAircraft] = useState([])
  const [callouts, setCallouts] = useState([])
  const [technicians, setTechnicians] = useState([])
  const [subtaskTechnicians, setSubtaskTechnicians] = useState([])
  const [projectTechnicians, setProjectTechnicians] = useState([])
  const [projectTechDates, setProjectTechDates] = useState([])
  const [flightLegs, setFlightLegs] = useState([])
  const [loading, setLoading] = useState(true)
  const loadedProjectIdsRef = useRef(new Set())

  const fetch = useCallback(async (isRefetch = false) => {
    if (!isRefetch) setLoading(true)
    try {
      const { data: p } = await fetchProjects()
      const projectList = p || []
      const activeIds = projectList.filter(proj => proj.status !== 'Complete').map(proj => proj.id)
      loadedProjectIdsRef.current = new Set()

      const [{ data: s }, { data: a }, { data: c }, { data: t }, { data: st }, { data: pt }, { data: ptd }, { data: fl }] = await Promise.all([
        fetchSubtasks(activeIds),
        fetchAircraft(),
        fetchCallouts(),
        fetchTechnicians(),
        fetchSubtaskTechnicians(),
        fetchProjectTechnicians(),
        fetchProjectTechDates(),
        fetchFlightLegs(),
      ])
      setProjects(projectList)
      setSubtasks(s || [])
      setAircraft(a || [])
      setCallouts(c || [])
      setTechnicians(t || [])
      setSubtaskTechnicians(st || [])
      setProjectTechnicians(pt || [])
      setProjectTechDates(ptd || [])
      setFlightLegs(fl || [])
    } catch (err) {
      console.error('useProjects fetch error:', err)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { fetch() }, [fetch])

  const refetch = useCallback(() => fetch(true), [fetch])

  const loadProjectSubtasks = useCallback(async (projectId) => {
    if (loadedProjectIdsRef.current.has(projectId)) return
    loadedProjectIdsRef.current.add(projectId)
    const { data } = await fetchSubtasksByProjectId(projectId)
    if (data) {
      setSubtasks(prev => [...prev.filter(s => s.project_id !== projectId), ...data])
    }
  }, [])

  return {
    projects, subtasks, aircraft, callouts, technicians,
    subtaskTechnicians, projectTechnicians, projectTechDates, flightLegs,
    loading, refetch, loadProjectSubtasks,
  }
}
